import { render, staticRenderFns } from "./TabInformationsThird.vue?vue&type=template&id=3f354c0e&scoped=true&"
import script from "./TabInformationsThird.vue?vue&type=script&lang=js&"
export * from "./TabInformationsThird.vue?vue&type=script&lang=js&"
import style0 from "./TabInformationsThird.vue?vue&type=style&index=0&id=3f354c0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f354c0e",
  null
  
)

export default component.exports